import React from "react";
import { Row, Col } from "react-bootstrap";
import { GatsbyImage } from "gatsby-plugin-image";
import { useTheme } from "../../context/ThemeContext";

const ImageGallery = ({ slice }) => {
  const { setCurrentImageIndex, handleShowImageModal, allGatsbyImageData } =
    useTheme();

  const renderGallery = slice.items.map((item, i) => {
    return (
      // eslint-disable-next-line react/no-array-index-key
      <div className="project-gallery" key={i}>
        {item.layout === "1 image, full width" && (
          <Row key={item.id} className="mb-4 one-image">
            <Col
              className="d-flex justify-content-center "
              onClick={() => {
                handleShowImageModal(true);
                setCurrentImageIndex(
                  allGatsbyImageData
                    .map((imageData) => imageData.images.fallback.src)
                    .indexOf(
                      item.left_image.gatsbyImageData.images.fallback.src
                    )
                );
              }}
            >
              {item.left_image.gatsbyImageData && (
                <GatsbyImage
                  image={item.left_image.gatsbyImageData}
                  alt={item.left_image.alt || "Project Image"}
                  className="d-flex"
                />
              )}
            </Col>
          </Row>
        )}
        {item.layout === "2 images, 50-50" && (
          <Row className="mb-4 d-flex">
            <Col
              md={6}
              className="mb-4 mb-md-0 d-flex"
              onClick={() => {
                handleShowImageModal(true);
                setCurrentImageIndex(
                  allGatsbyImageData
                    .map((imageData) => imageData.images.fallback.src)
                    .indexOf(
                      item.left_image.gatsbyImageData.images.fallback.src
                    )
                );
              }}
            >
              {item.left_image.gatsbyImageData && (
                <GatsbyImage
                  image={item.left_image.gatsbyImageData}
                  alt={item.left_image.alt || "Project Image"}
                />
              )}
            </Col>
            <Col
              md={6}
              className="d-flex"
              onClick={() => {
                handleShowImageModal(true);
                setCurrentImageIndex(
                  allGatsbyImageData
                    .map((imageData) => imageData.images.fallback.src)
                    .indexOf(
                      item.right_image.gatsbyImageData.images.fallback.src
                    )
                );
              }}
            >
              {item.right_image.gatsbyImageData && (
                <GatsbyImage
                  image={item.right_image.gatsbyImageData}
                  alt={item.right_image.alt || "Project Image"}
                />
              )}
            </Col>
          </Row>
        )}
        {item.layout === "2 images, 70-30" && (
          <Row className="mb-4 d-flex">
            <Col
              md={8}
              className="mb-4 mb-md-0 d-flex"
              onClick={() => {
                handleShowImageModal(true);
                setCurrentImageIndex(
                  allGatsbyImageData
                    .map((imageData) => imageData.images.fallback.src)
                    .indexOf(
                      item.left_image.gatsbyImageData.images.fallback.src
                    )
                );
              }}
            >
              {item.left_image.gatsbyImageData && (
                <GatsbyImage
                  image={item.left_image.gatsbyImageData}
                  alt={item.left_image.alt || "Project Image"}
                />
              )}
            </Col>
            <Col
              md={4}
              className="d-flex"
              onClick={() => {
                handleShowImageModal(true);
                setCurrentImageIndex(
                  allGatsbyImageData
                    .map((imageData) => imageData.images.fallback.src)
                    .indexOf(
                      item.right_image.gatsbyImageData.images.fallback.src
                    )
                );
              }}
            >
              {item.right_image.gatsbyImageData && (
                <GatsbyImage
                  image={item.right_image.gatsbyImageData}
                  alt={item.right_image.alt || "Project Image"}
                />
              )}
            </Col>
          </Row>
        )}
        {item.layout === "2 images, 30-70" && (
          <Row className="mb-4 d-flex">
            <Col
              md={4}
              className="d-flex mb-4 mb-md-0"
              onClick={() => {
                handleShowImageModal(true);
                setCurrentImageIndex(
                  allGatsbyImageData
                    .map((imageData) => imageData.images.fallback.src)
                    .indexOf(
                      item.left_image.gatsbyImageData.images.fallback.src
                    )
                );
              }}
            >
              {item.left_image.gatsbyImageData && (
                <GatsbyImage
                  image={item.left_image.gatsbyImageData}
                  alt={item.left_image.alt || "Project Image"}
                />
              )}
            </Col>
            <Col
              md={8}
              className="d-flex"
              onClick={() => {
                handleShowImageModal(true);
                setCurrentImageIndex(
                  allGatsbyImageData
                    .map((imageData) => imageData.images.fallback.src)
                    .indexOf(
                      item.right_image.gatsbyImageData.images.fallback.src
                    )
                );
              }}
            >
              {item.right_image.gatsbyImageData && (
                <GatsbyImage
                  image={item.right_image.gatsbyImageData}
                  alt={item.right_image.alt || "Project Image"}
                />
              )}
            </Col>
          </Row>
        )}
      </div>
    );
  });

  return <div className="my-4">{renderGallery}</div>;
};

export default ImageGallery;
